import { Link } from 'react-router-dom';

/* A big Back button for the top of an inner page.
 *
 * Installed on a phone, the app has no browser chrome, and the breadcrumb is
 * 11.5px text: too small to tap. This is the thumb-sized way back. Pass `to`
 * to go to a route, or `onClick` to step back inside a page (the request
 * wizard). The breadcrumb stays; it still says where you are. */
export default function BackButton({ to, onClick, children = 'Back' }) {
  const inner = (
    <>
      <span className="material-symbols-outlined" aria-hidden="true">arrow_back</span>
      {children}
    </>
  );
  if (to) {
    return <Link to={to} className="btn btn--quiet btn--back">{inner}</Link>;
  }
  return <button type="button" className="btn btn--quiet btn--back" onClick={onClick}>{inner}</button>;
}
